import { Col, Row } from "antd";
import { ConversationsContainer } from "./components/Conversations";
import { useMemo, useState } from "react";
import { ISelectedConversation } from "./types/SelectedConversation";
import { MessagesSide } from "./components/MessagesSide";

export const Messages = () => {
  const [conversation, setConversation] =
    useState<ISelectedConversation | null>(null);

  const containerClassName: string = useMemo(
    () => `w-100 messages-page ${conversation ? "item-selected" : ""}`,
    [conversation]
  );

  const messagesContainer: string = useMemo(
    () =>
      `messages_container h-100 flex-column ${
        !conversation ? "not-opened" : ""
      }`,
    [conversation]
  );

  const key: string = useMemo(
    () => `conv_${conversation ? conversation.id : "not-selected"}`,
    [conversation]
  );

  return (
    <Row className={containerClassName}>
      <Col className="conversations_container h-100">
        <ConversationsContainer
          conversation={conversation}
          setConversation={setConversation}
        />
      </Col>
      <Col className={messagesContainer}>
        {conversation && (
          <MessagesSide
            conversation={conversation}
            setConversation={setConversation}
            key={key}
          />
        )}
      </Col>
    </Row>
  );
};
